import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSubjects,
  fetchClasses,
  saveSubject,
  deleteSubject,
  createSubject,
  getSubjects,
  deleteSubjectBoard,
} from "./subjectThunk";

const initialState = {
  subjects: [],
  subjectsList: [],
  pagination: { currentPage: 1, totalPages: 1 },
  classes: [],
  subjectName: "",
  selectedClassIds: [],
  editingSubject: null,
  loading: false,
  error: null,
  showForm: false,
};

const subjectSlice = createSlice({
  name: "subject",
  initialState,
  reducers: {
    setSubjectName: (state, action) => {
      state.subjectName = action.payload;
    },
    toggleClassSelection: (state, action) => {
      const id = action.payload;
      if (state.selectedClassIds.includes(id)) {
        state.selectedClassIds = state.selectedClassIds.filter(
          (cid) => cid !== id,
        );
      } else {
        state.selectedClassIds.push(id);
      }
    },
    setEditingSubject: (state, action) => {
      const sub = action.payload;
      state.editingSubject = sub;
      state.subjectName = sub.subject_name || "";
      state.selectedClassIds = sub.class_ids || [];
    },
    clearEdit: (state) => {
      state.editingSubject = null;
      state.subjectName = "";
      state.selectedClassIds = [];
    },
    setShowForm: (state, action) => {
      state.showForm = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubjects.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubjects.fulfilled, (state, action) => {
        state.loading = false;
        state.subjects = action.payload;
      })
      .addCase(fetchSubjects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getSubjects.pending, (state) => {
      state.loading = true;
    })

    .addCase(getSubjects.fulfilled, (state, action) => {
      state.loading = false;
      state.subjectsList = action.payload.subjects;
      state.pagination = action.payload.pagination;
    })

    .addCase(getSubjects.rejected, (state) => {
      state.loading = false;
    })
      .addCase(fetchClasses.fulfilled, (state, action) => {
        state.classes = action.payload;
      })
      .addCase(saveSubject.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveSubject.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(saveSubject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteSubject.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSubject.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteSubject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createSubject.pending, (state) => {
        state.loading = true;
      })
      .addCase(createSubject.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createSubject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message;
      })
      .addCase(deleteSubjectBoard.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSubjectBoard.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteSubjectBoard.rejected, (state) => {
        state.loading = false;
      })
  },
});

export const {
  setSubjectName,
  toggleClassSelection,
  setEditingSubject,
  clearEdit,
  setShowForm,
} = subjectSlice.actions;

export default subjectSlice.reducer;
